module.exports = __webpack_public_path__ + "img/step4a-mobile-fr.5e1ed53c.webp";